module.exports = __webpack_public_path__ + "img/card-back.71676531.png";